/* Corewella cart-drawer subscription toggle.
 * Handles "Upgrade to Subscription" and "Switch to one-time" buttons on cart line items.
 * Calls /cart/change.js with the line's key and the selling_plan id (or empty string for one-time).
 */
(function () {
  'use strict';

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.dataset.corewellaBusy = busy ? '1' : '';
    if (busy) {
      btn.dataset.corewellaOriginalText = btn.textContent;
      btn.textContent = 'Updating cart…';
    } else if (btn.dataset.corewellaOriginalText) {
      btn.textContent = btn.dataset.corewellaOriginalText;
    }
  }

  function changeLine(lineKey, sellingPlanId, btn) {
    setBusy(btn, true);
    var body = new FormData();
    body.append('id', lineKey);
    // Empty string clears the selling plan; an id sets it.
    body.append('selling_plan', sellingPlanId || '');

    return fetch('/cart/change.js', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Reload to repaint cart drawer with new subscription state and pricing.
        window.location.reload();
      })
      .catch(function () {
        setBusy(btn, false);
      });
  }

  document.addEventListener('click', function (e) {
    var upgradeBtn = e.target.closest('.corewella-cart-upgrade');
    if (upgradeBtn) {
      if (upgradeBtn.dataset.corewellaBusy) return;
      e.preventDefault();
      changeLine(upgradeBtn.dataset.lineKey, upgradeBtn.dataset.planId, upgradeBtn);
      return;
    }

    var downgradeBtn = e.target.closest('.corewella-cart-downgrade');
    if (downgradeBtn) {
      if (downgradeBtn.dataset.corewellaBusy) return;
      e.preventDefault();
      changeLine(downgradeBtn.dataset.lineKey, '', downgradeBtn);
    }
  });
})();
